import { useState } from 'react';
import { UserPlus } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { ownerApi, apiError } from './ownerApi';

// İlk uygulama yöneticisi (Süper Admin) yalnız Platform Sahibi tarafından oluşturulur
export const FirstAdminCard = () => {
  const [f, setF] = useState({ name: '', email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault(); setBusy(true);
    ownerApi.post('/platform-owner/first-admin', f).then(() => { toast.success('İlk uygulama yöneticisi oluşturuldu'); setF({ name: '', email: '', password: '' }); })
      .catch((err) => toast.error(apiError(err))).finally(() => setBusy(false));
  };
  return (
    <form onSubmit={submit} className="space-y-3 rounded-2xl border border-slate-200 bg-white p-6" data-testid="owner-first-admin-card">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-50 text-orange-500"><UserPlus className="h-5 w-5" /></span>
        <div><h2 className="text-lg font-semibold text-slate-900">İlk Uygulama Yöneticisi</h2><p className="text-xs text-slate-500">Yalnız hiç yönetici yokken kullanılabilir</p></div>
      </div>
      <Input placeholder="Ad Soyad" value={f.name} onChange={set('name')} required data-testid="owner-first-admin-name" />
      <Input type="email" placeholder="E-posta" value={f.email} onChange={set('email')} required data-testid="owner-first-admin-email" />
      <Input type="password" placeholder="Şifre" value={f.password} onChange={set('password')} required minLength={8} data-testid="owner-first-admin-password" />
      <Button type="submit" disabled={busy} className="w-full" data-testid="owner-first-admin-submit">Oluştur</Button>
    </form>
  );
};
